import { useEffect, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import type { MvpFlow } from '@/lib/mvpFlow';

interface FlowLockProps {
  flow: MvpFlow;
  children: ReactNode;
}

// MVP: el usuario normal sólo ve el flujo que eligió con el primer botón de la
// home (persistido en backend como user.chosenFlow). Si intenta entrar al otro
// flujo se le redirige al suyo. El primer acceso a un flujo (sin elección
// previa) fija la elección. El SuperUser no tiene restricción.
export default function FlowLock({ flow, children }: FlowLockProps) {
  const { isSuperUser, user, chooseFlow } = useAuth();
  const chosen = user?.chosenFlow ?? null;

  useEffect(() => {
    if (user && !isSuperUser && !chosen) {
      chooseFlow(flow).catch(() => {
        // Sin red: la elección se reintenta en el próximo acceso al flujo.
      });
    }
  }, [user, isSuperUser, chosen, flow, chooseFlow]);

  if (!isSuperUser && chosen && chosen !== flow) {
    return <Navigate to={`/${chosen}`} replace />;
  }

  return <>{children}</>;
}
